export const getLabel = (label, required) => {
  if (!label) return null;

  return label + (required ? ' *' : '');
};
